import { EventEmitter } from "events";
import { ElaborationStatus } from "../../redux/feature/object/remote-elaborations-slice";

export interface LoadingManagerData {
  isAbortable: boolean;
  items: ElaborationStatus[];
}

class LoadingManager extends EventEmitter {
  constructor() {
    super();
    this.requesters = new Map();
  }

  requesters: Map<string, LoadingManagerData>;

  create(requester, data?: LoadingManagerData | null) {
    this.requesters.set(requester, data);
    this.emitChange();
  }

  remove(requester) {
    this.requesters.delete(requester);
    this.emitChange();
  }

  removeAll() {
    this.requesters.clear();
  }

  emitChange() {
    this.emit("loading", this.requesters);
  }

  addChangeListener(callback) {
    this.addListener("loading", callback);
  }

  removeChangeListener(callback) {
    this.removeListener("loading", callback);
  }
}

export default new LoadingManager();
